import { render, staticRenderFns } from "./Loadboard.vue?vue&type=template&id=a4191a9a&scoped=true&"
import script from "./Loadboard.vue?vue&type=script&lang=js&"
export * from "./Loadboard.vue?vue&type=script&lang=js&"
import style0 from "./Loadboard.vue?vue&type=style&index=0&id=a4191a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4191a9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
